// Reads the ad identifiers from the page URL.
//
// Two ways in:
//  1. Query parameters from Meta: ?campaign_name=...&adset_name=...&ad_name=...
//  2. A code in the path: /repsol-881. The code is saved in the Ad column when
//     the ad didn't bring its own ad_name, so you can look the ad up later.
// Meta placeholders that were never filled in ("{{ad.name}}") count as empty.

const clean = (value) => {
  const text = (value || "").trim();
  return /^\{\{.*\}\}$/.test(text) ? "" : text;
};

export const getPathCode = () => {
  const first = window.location.pathname.split("/").filter(Boolean)[0] || "";
  let decoded = first;
  try {
    decoded = decodeURIComponent(first);
  } catch (e) {
    // keep the raw segment
  }
  return decoded.toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 60);
};

export const getAdParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    campaign_name: clean(params.get("campaign_name")),
    adset_name: clean(params.get("adset_name")),
    ad_name: clean(params.get("ad_name")) || getPathCode(),
    user_ip: clean(params.get("user_ip")),
  };
};

// Looks up the visitor's public IP. Resolves to "" if the lookup fails or is
// blocked (ad blockers do this); the form still works without it.
export const fetchVisitorIp = async () => {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    const res = await fetch("https://api.ipify.org?format=json", {
      signal: controller.signal,
    });
    clearTimeout(timer);
    const json = await res.json();
    return typeof json.ip === "string" ? json.ip : "";
  } catch (e) {
    return "";
  }
};
